/*@ngInject*/
const PolicyCancellationActionsMediator = function (policyActionRepository) {

    this.deleteDraftCancellation = function (policyCancellationId) {
        return policyActionRepository.deleteDraftCancellation(policyCancellationId);
    };

    this.submitForCancellation = function (policyCancellationId) {
        return policyActionRepository.submitForCancellation(policyCancellationId);
    };

    this.markAsCancelled = function (policyCancellationId) {
        return policyActionRepository.markAsCancelled(policyCancellationId);
    };

    this.revertToCancellationPending = function (policyCancellationId, reason, detail) {
        return policyActionRepository.revertToCancellationPending(policyCancellationId, reason, detail);
    };

    this.rescindCancellation = function (policyCancellationId, reason, detail) {
        return policyActionRepository.rescindCancellation(policyCancellationId, reason, detail);
    };

    this.requestCancellation = function (policyCancellationId) {
        return policyActionRepository.requestCancellation(policyCancellationId);
    };

    this.retractCancellationRequest = function (policyCancellationId, reason, detail) {
        return policyActionRepository.retractCancellationRequest(policyCancellationId, reason, detail);
    };
};

angular.module('gw-um-submission')
    .service('policyCancellationActionsMediator', PolicyCancellationActionsMediator);
